/**
 * Состояние джобы импорта на ws-сервере.
 * accepted - задача принята, но еще не начала работу; running - выполняется;
 * completed/failed - терминальные.
 */
export type ImportJobStatus = 'accepted' | 'running' | 'completed' | 'failed';

export type ImportJobKind = 'manual' | 'tabel' | 'full' | 'users';

export interface ImportJobLogEntry {
	at: string;
	level: 'info' | 'error';
	message: string;
}

export interface ImportJobDto {
	id: string;
	kind: ImportJobKind;
	status: ImportJobStatus;
	/** Текущий шаг: «Импорт расписания» и т.п. */
	step: string | null;
	steps_done: number;
	steps_total: number;
	started_at: string;
	finished_at: string | null;
	error: string | null;
	log: ImportJobLogEntry[];
}

/** Ответ ws на запуск импорта. accepted=false - импорт уже шел, новый не запускался */
export interface ImportJobResponse {
	success: boolean;
	accepted: boolean;
	job: ImportJobDto | null;
	error: string | null;
}

export const isTerminalJobStatus = (status: ImportJobStatus): boolean => status === 'completed' || status === 'failed';
